import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { NewLoginModalComponent } from '../new-login-modal/new-login-modal.component';
import { NewResetPasswordComponent } from '../new-reset-password/new-reset-password.component';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { LocalServiceService } from 'src/app/shareModule/services/local-service.service';

@Component({
  selector: 'app-new-homepage',
  templateUrl: './new-homepage.component.html',
  styleUrls: ['./new-homepage.component.scss']
})
export class NewHomepageComponent implements OnInit {

  constructor(
    private route: ActivatedRoute,
    private modalService: NgbModal,
    private local: LocalServiceService,
  ) { }

  isFusionStore: boolean = false

  ngOnInit(): void {
    this.local.logout();
    const currentUrl = window.location.href;
    
    if (currentUrl == "https://fusionapp.store/#/") {
      this.isFusionStore = true
      document.getElementById("main_banner").style.setProperty('background', "url('../../../../assets/images/admin/fusionBanner.jpeg')", 'important');
      document.getElementById("main_banner").style.setProperty('background-size', "cover", 'important');
      document.getElementById("main_banner").style.setProperty('min-height', "100vh", 'important');
      document.getElementById("main_banner").style.setProperty('background-position', "center bottom", 'important');
    }

    this.route.queryParams.subscribe((res: any) => {

      if (res.hasOwnProperty('v')) {
        if (res.v == 'true') {
          this.modalService.open(NewLoginModalComponent, { size: 'lg', ariaLabelledBy: 'modal-basic-title', windowClass: 'v2_login_model' });
        }
      }

      if (res.hasOwnProperty('r') && res.hasOwnProperty('id')) {
        if (res.r == 'true' && res.id.trim() != '') {
          this.modalService.open(NewResetPasswordComponent, { size: 'lg', ariaLabelledBy: 'modal-basic-title', windowClass: 'v2_login_model' });
        }
      }
    });
  }

}
